"use client";

import { AudioPlayerDownloadConversion } from "@/components/audioPlayers/audioPlayerDownloadConversion/AudioPlayerDownloadConversion";
import { AudioPlayerDownloadConversionMulti } from "@/components/audioPlayers/AudioPlayerDownloadConversionMulti/AudioPlayerDownloadConversionMulti";
import { Heading4 } from "@/components/text/Heading4";
import {
  ConversionConstructedNoDates,
  MixedModelConstructedNoDates,
  ModelNoDates,
  UserNoDates,
} from "@/types/types";
import { isConversionMulti } from "@/utils/isConversionMulti";

export function ConversionHistory({
  conversionHistory,
  models,
  mixedModelsConstructed,
  user,
}: {
  conversionHistory: (
    | ConversionConstructedNoDates
    | ConversionConstructedNoDates[]
  )[];
  models: ModelNoDates[] | null;
  mixedModelsConstructed: MixedModelConstructedNoDates[] | null;
  user: UserNoDates;
}) {
  const getConversionId = (
    conversionItem:
      | ConversionConstructedNoDates
      | ConversionConstructedNoDates[]
  ) => {
    return isConversionMulti(conversionItem) ?
        conversionItem.map((c) => c.id).join("-")
      : conversionItem.id;
  };

  return (
    <>
      <Heading4 elementType="h2" className="mb-4 mt-6">
        History
      </Heading4>

      <div className="flex h-full flex-col gap-y-4 overflow-auto rounded-3xl p-2 pr-2 md:max-h-[700px]">
        {conversionHistory.map((conversionItem) => (
          <div key={getConversionId(conversionItem)}>
            {isConversionMulti(conversionItem) ?
              <AudioPlayerDownloadConversionMulti
                conversionMulti={conversionItem}
                models={models}
                mixedModelsConstructed={mixedModelsConstructed}
                user={user}
              />
            : <AudioPlayerDownloadConversion
                conversion={conversionItem}
                user={user}
                models={models}
                mixedModelsConstructed={mixedModelsConstructed}
              />
            }
          </div>
        ))}
      </div>
    </>
  );
}
